import axios from 'axios';

export async function getIPForVisitor () {
    const response = await axios('/get-ip');
    if (response.status === 200) {
        try {
            return response.data.ip
        } catch(err){
            console.log(err)
        }
    }
}
